const chatTranslationsEN = {
  messagingCenterTitle: 'Message Center',
  messagingCenter: 'Messages',
  systemAdminName: 'Sayma Admin',
  chatInputPlaceholder: 'Type your message',
  sendButtonTooltip: 'Send message',
  searchInputPlaceholder: 'Search',
  totalMessagesPostfix: 'message(s)',
  noMessages: 'No Messages'
};

export default chatTranslationsEN;
